import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import type { FC, ReactNode } from 'react';

import './styles.scss';

export type PageModalProps = {
  isOpen?: boolean;
  hasHeader?: boolean;
  containerClassName?: string;
  headerClassName?: string;
  bodyClassName?: string;
  title?: ReactNode;
  onClose?(): void;
  children?: ReactNode;
};

export const PageModal: FC<PageModalProps> = ({
  isOpen,
  hasHeader = true,
  containerClassName = '',
  headerClassName = '',
  bodyClassName = '',
  title,
  onClose,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div className={`page-modal ${containerClassName}`}>
      {hasHeader && (
        <div className={`page-modal__header ${headerClassName}`}>
          {title && <div className="page-modal__header__title">{title}</div>}

          {onClose && (
            <Button type="text" icon={<CloseOutlined />} onClick={onClose} />
          )}
        </div>
      )}

      <div className={`page-modal__body ${bodyClassName}`}>{children}</div>
    </div>
  );
};
